module.exports = __webpack_public_path__ + "static/img/button_active1.754721e7.png";